// SwiperWithDefaultStyle.js
'use strict';
import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

// It's default swiper's style.
// you can customize style in your component by overriding css like:
//
// const CustomizedSwiper = styled(SwiperWithDefaultStyle)`
//   your style here...
// `;

export const SwiperWithDefaultStyle = styled(Swiper)`
  width: 100%;
  height: 100%;
  touch-action: pan-y;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-slide {
    flex-shrink: 0;
    position: relative;
    transition-property: transform;
  }
`;

export const SwiperAutoHeightStyle = css`
  // Integrate with css below in swiper-bundle.css
  /* Auto Height */
  /*   
  .swiper-autoheight,
  .swiper-autoheight .swiper-slide {
    height: auto;
  }
  .swiper-autoheight .swiper-wrapper {
    align-items: flex-start;
    transition-property: transform, height;
  }
  .swiper-backface-hidden .swiper-slide {
    transform: translateZ(0);
    backface-visibility: hidden;
  }
 */

  height: auto;
  .swiper-wrapper {
    height: auto;
    align-items: flex-start;
  }
  .swiper-slide {
    width: 100%;
    height: auto;
  }
`;

export const SwiperPaginationDefaultStyle = css`
  position: relative;

  .swiper-slide {
    overflow: hidden;
  }

  .swiper-pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
    &.swiper-pagination-hidden {
      opacity: 0;
    }
  }

  .swiper-pagination-clickable {
    .swiper-pagination-bullet {
      cursor: pointer;
    }
  }

  .swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0;
  }

  .swiper-pagination-bullets {
    bottom: 0;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;

    .swiper-pagination-bullet {
      border: none;
      margin: 0;
      padding: 0;
      box-shadow: none;
      appearance: none;

      width: 6px;
      height: 6px;
      opacity: 0.3;
      display: inline-block;
      border-radius: 50%;
      background: #ffffff;

      margin: 0 4px;
      transition: 200ms transform, 200ms left;
    }
    .swiper-pagination-bullet {
      position: relative;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      transform: scale(1);
    }
    .swiper-pagination-bullet-active-main {
      transform: scale(1);
    }
    .swiper-pagination-bullet-active-prev {
      transform: scale(0.66);
    }
    .swiper-pagination-bullet-active-prev-prev {
      transform: scale(0.33);
    }
    .swiper-pagination-bullet-active-next {
      transform: scale(0.66);
    }
    .swiper-pagination-bullet-active-next-next {
      transform: scale(0.33);
    }
    .swiper-pagination-bullet:only-child {
      display: none !important;
    }
  }

  .swiper-pagination-fraction {
    /*  */
  }

  .swiper-container-rtl {
    .swiper-pagination-bullet {
      transition: 200ms transform, 200ms right;
    }
  }

  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
`;
export default SwiperWithDefaultStyle;
